require('../../sass/components/_file.scss');

export const File = {
    name: 'File',
    props: {
        id: {
            type: String,
            required: true
        },
        fileLabel: {
            type: String,
            default: 'dodaj plik'
        },
        value: [String, Object],
        name: String,
        disabled: Boolean
    },
    data() {
        return {fileName: ''};
    },
    computed: {
        rootClasses() {
            return [
                'file',
                'file--vue',
                this.fileName ? 'file--picked' : undefined
            ]
        },
        label() {
            return this.fileName || this.fileLabel;
        }
    },
    methods: {
        onChange() {
            if (this.$refs.input.files.length) {
                this.fileName = this.$refs.input.files.item(0).name;
            } else {
                this.fileName = '';
            }
            this.$emit('input', this.fileName);
        }
    },
    template: `
        <div :class="rootClasses">
            <input type="file" ref="input" :name="name" :disabled="disabled" :id="id" @change="onChange"/>
            <label :for="id">{{label}}</label>
        </div>
`
};